import { FunctionComponent } from 'react'
import { StepProps } from 'components/Wizards/MultiStepWizard/Types'

export const multiStep =
  <P extends StepProps>(Component: FunctionComponent<P>) =>
  (props: Partial<P>) =>
    <Component {...(props as P)} />
